import React from "react";

const Compass03Icon = ({ color = "currentColor", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
      stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.0416 6.19947C11.408 6.07734 11.5912 6.01627 11.713 6.05971C11.819 6.09752 11.9025 6.18095 11.9403 6.28697C11.9837 6.4088 11.9227 6.59201 11.8005 6.95842L10.6849 10.3054C10.6501 10.4097 10.6327 10.4619 10.6031 10.5053C10.5768 10.5436 10.5436 10.5768 10.5053 10.6031C10.4619 10.6327 10.4097 10.6501 10.3054 10.6849L6.95842 11.8005C6.59201 11.9227 6.4088 11.9837 6.28697 11.9403C6.18095 11.9025 6.09752 11.819 6.05971 11.713C6.01627 11.5912 6.07734 11.408 6.19947 11.0416L7.31513 7.69461C7.34992 7.59025 7.36731 7.53807 7.39695 7.49474C7.4232 7.45636 7.45636 7.4232 7.49474 7.39695C7.53807 7.36731 7.59025 7.34992 7.69461 7.31513L11.0416 6.19947Z"
      stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Compass03Icon;
